import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { ModalBase, ModalBaseProps, ModalSpacing, ModalStyle } from '..';
import { ReactNode } from 'react';

interface IMessageModalButton {
  kind: string;
  cancelLabel?: string;
  cancelButtonClassName?: string;
  onCancel: () => void;
}

export interface IMessageModalNoneButton extends IMessageModalButton {
  kind: 'none';
}

export interface IMessageModalCloseButton extends IMessageModalButton {
  kind: 'close' | 'bank_close';
}

export interface IMessageModalConfirmButton extends IMessageModalButton {
  kind: 'confirm' | 'bank_confirm';
  submitLabel: string;
  onSubmit: () => void;
  cancelLabel: string;
  onCancel: () => void;
}

export type MessageModalButtonProps = IMessageModalCloseButton | IMessageModalConfirmButton | IMessageModalNoneButton;

export type MessageModalProps = {
  message: string | ReactNode;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  button: MessageModalButtonProps;
  shouldCloseOnOverlayClick?: boolean;
  spacing?: ModalSpacing;
};

export const MessageModal: React.FC<MessageModalProps> = ({
  message,
  isOpen,
  setIsOpen,
  button,
  shouldCloseOnOverlayClick = true,
  spacing,
}) => {
  return (
    <ModalBase
      isOpen={isOpen}
      modalStyle={ModalStyle.Message}
      onRequestClose={() => button.onCancel()}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      spacing={spacing}
    >
      <>
        <div className="title">{message}</div>
        <MessageModalButton {...button} setIsOpen={setIsOpen} />
      </>
    </ModalBase>
  );
};

export const ContentModal: React.FC<MessageModalProps> = ({
  message,
  isOpen,
  setIsOpen,
  button,
  shouldCloseOnOverlayClick = true,
}) => {
  return (
    <ModalBase
      isOpen={isOpen}
      modalStyle={ModalStyle.Message}
      onRequestClose={() => button.onCancel()}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      {message}
    </ModalBase>
  );
};

export const MessageModalButton = (
  props: MessageModalButtonProps & {
    setIsOpen: (isOpen: boolean) => void;
  },
) => {
  switch (props.kind) {
    case 'close':
      return (
        <div className={`buttons ${props.cancelButtonClassName || ''}`}>
          <Button
            label={props.cancelLabel}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            onClick={() => {
              props.onCancel();
            }}
          />
        </div>
      );
    case 'confirm':
      return (
        <div className="buttons">
          <Button
            label={props.cancelLabel}
            buttonFill={ButtonFill.white}
            buttonSize={ButtonSize.xsmall}
            onClick={props.onCancel}
          />
          <Button
            label={props.submitLabel}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            onClick={props.onSubmit}
          />
        </div>
      );
    case 'bank_close':
      return (
        <div className="buttons">
          <Button
            label={props.cancelLabel}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            onClick={() => {
              props.onCancel();
            }}
          />
        </div>
      );
    case 'bank_confirm':
      return (
        <div className="buttons">
          <Button
            label={props.cancelLabel}
            buttonFill={ButtonFill.white}
            buttonSize={ButtonSize.xsmall}
            onClick={props.onCancel}
          />
          <Button
            label={props.submitLabel}
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.xsmall}
            onClick={props.onSubmit}
          />
        </div>
      );
    case 'none':
    default:
      return (
        // <div className="buttons">
        //     <Button
        //       label={'aiu'}
        //       buttonFill={ButtonFill.black}
        //       buttonSize={ButtonSize.xsmall}
        //       onClick={() => {
        //         props.onCancel();
        //       }}
        //     />
        //   </div>
        <></>
      );
  }
};
